import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import queryString from 'query-string';

class Sidebar extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			open_dropdown: false,
			current_url: null,
		}
	}

	componentDidUpdate() {
		if (this.state.current_url !== this.props.current_url) {
			this.setState({
				current_url: this.props.current_url,
				open_dropdown: (window.location.href.includes('colis/shipped'))
			})
		}
	}

	render() {
		const livreur = this.props.livreur;
		const current_time = this.props.current_time;

		return (
			<div id='sidebar' className='sidebar app-menu'>
				<Link to={`/home?t=${current_time}`} replace>
					<div className="sidebar-profile text-center">
						<figure className="avatar avatar-120 avatar-circle"><img src={livreur.livreur_photo} alt="user" /></figure>
						<div className="dropdown mt-3">
							<button className="btn btn-link dropdown-toggle no-caret w-100" type="button">
								<span className="d-flex justify-content-center">
									<span className="ml-3">
										{livreur.livreur_name}<br />
										<span className="text-mute small">{livreur.livreur_function}</span>
									</span>
								</span>
							</button>
						</div>
					</div>
				</Link>
				<ul className="nav flex-column">
					<li className="nav-item brd-bottom">
						<Link replace to={`/home?t=${current_time}`}  className={`nav-link${this.getActiveLink('/')}`}>
							<i className="material-icons icon">home</i>
							<span className="menu-text">Tableau de bord</span>
						</Link>
					</li>
					<li className="nav-item brd-bottom">
						<a href="/#" className={`nav-link dropdown-nav${this.state.open_dropdown ? ' active' : ''}`} onClick={(event) => this.openDropdown(event)}>
							<i className="material-icons icon">emoji_transportation</i>
							<span className="menu-text">En cours de livraison ({livreur.livreur_total_shipped})</span>
							<i className="material-icons icon-right">keyboard_arrow_down</i>
						</a>
						<ul className={`nav flex-column${this.state.open_dropdown ? ' d-block' : ''}`}>
							<li className="nav-item">
								<Link replace to={`/colis/shipped?t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/shipped')}`}>
									En cours ({livreur.livreur_total_encours})
								</Link>
							</li>
							
							<li className="nav-item">
								<Link replace to={`/colis/shipped?statut_shipped=shipped_reported&t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/shipped?statut_shipped=shipped_reported')}`}>
									Reporté ({livreur.livreur_total_shipped_reported})
								</Link>
							</li>
							<li className="nav-item">
								<Link replace to={`/colis/shipped?statut_shipped=shipped_injoignable&t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/shipped?statut_shipped=shipped_injoignable')}`}>
									Injoignable ({livreur.livreur_total_shipped_injoignable})
								</Link>
							</li>
							

                            <li className="nav-item fhide">
								<Link replace to={`/colis/shipped?statut_shipped=without_motif&t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/shipped?statut_shipped=without_motif')}`}>
									Sans appels ({livreur.livreur_total_shipped_without_motif})
								</Link>
							</li>

                            <li className="nav-item">
								<Link replace to={`/colis/shipped?statut_shipped=shipped_refused&t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/shipped?statut_shipped=shipped_refused')}`}>
									Refusé par le client ({livreur.livreur_total_shipped_refused})
								</Link>
							</li>
						</ul>
					</li>
					<li className="nav-item brd-bottom">
						<Link replace to={`/colis/delivered?t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/delivered')}`}>
							<i className="material-icons icon">check_circle</i>
							<span className="menu-text">Livré ({livreur.livreur_total_delivered})</span>
						</Link>
					</li>
					<li className="nav-item brd-bottom">
						<Link replace to={`/colis/undelivered?t=${current_time}`} className={`nav-link${this.getActiveLink('/colis/undelivered')}`}>
							<i className="material-icons icon">assignment_return</i>
							<span className="menu-text">Retours ({livreur.livreur_total_undelivered})</span>
						</Link>
					</li>

					<li className="nav-item brd-bottom fhide">
						<Link replace to={`/messages?t=${current_time}`} className={`nav-link${this.getActiveLink('/messages/')}`} className="nav-link">
							<i className="material-icons icon">messages</i>
							<span className="menu-text">Messages ({livreur.total_messages})</span>
						</Link>
					</li>

                    <li className="nav-item brd-bottom">
						<Link replace to={`/factures?t=${current_time}`} className={`nav-link${this.getActiveLink('/factures/')}`} className="nav-link">
							<i className="material-icons icon">money</i>
							<span className="menu-text">Mes factures ({livreur.total_factures})</span>
						</Link>
					</li>

					<li className="nav-item brd-bottom">
						<Link  replace to={`/resume?t=${current_time}`} className={`nav-link${this.getActiveLink('/resume')}`}>
							<i className="material-icons icon">account_balance</i>
							<span className="menu-text">Situation Financière</span>
						</Link>
					</li>
				</ul>
			</div>
		);
	}

	getActiveLink = (path) => {
		const loc = this.props.location;
		const params = queryString.parse(loc.search);
		var lnk = loc.pathname
		if (params.statut_shipped) {
			lnk += '?statut_shipped=' + params.statut_shipped
		}
		return lnk === path ? ' active' : '';
	}

	openDropdown = (event) => {
		event.preventDefault();
		const open_dropdown = this.state.open_dropdown === false ? true : false;
		this.setState({ open_dropdown: open_dropdown });
	}

}

export default withRouter(Sidebar)